import { Component, Input, OnInit, signal } from '@angular/core';
import { Grouping } from 'app/classes/grouping';
import { RuleNotification } from 'app/classes/rule-service/rule-notification';
import { RulePackage } from 'app/classes/rule-service/rule-package';
import { OrgService } from 'app/shared/org.service';

@Component({
  selector: 'app-rulesv3-item-contacts',
  templateUrl: './rulesv3-item-contacts.component.html',
  styleUrls: ['./rulesv3-item-contacts.component.css'],
  standalone: false
})
export class Rulesv3ItemContactsComponent implements OnInit {
  @Input()

  public set rule(v: RulePackage) {
    this.groupings = v?.groupings || undefined;
    this.notifications = v?.notifications || undefined;
  }

  groupings: Grouping[];
  notifications: RuleNotification[];

  groupingsAvailable = signal<any>(null);

  constructor(private orgService: OrgService) {

  }

  ngOnInit(): void {
    this.orgService.getGroupingsAndUsers().then((groupings) => {
      this.groupingsAvailable.set({});

      this.groupingsAvailable.update(gp => {
        groupings.forEach(g => gp[g.id] = g);
        return gp;
      });

    });
  }

}
